var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAction',[_c('SecondaryButton',{attrs:{"loading":_vm.isLoading,"color":"primary"},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('inline-svg',{attrs:{"src":require('@/assets/svg/thumb_up.svg'),"width":"25"}}),_vm._v(" Approve ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }